import {useLocation} from 'react-router-dom'

export const useQuery = () => {
  const search = new URLSearchParams(useLocation().search);
  const map = {}
  for(let pair of search.entries()) {
    map[pair[0]] = pair[1]
  }
  return map
}